<template>
  <div class="side-bar" :class="{ 'side-bar--active': isMobileActive }">
    <div class="side-bar__row" ref="contracts">
      <h3>{{ $t('sideBarInfo.contracts') }}</h3>
      <div class="side-bar__documents">
        <ul class="side-bar__documents__list" :style="documentsListWidth">
          <template v-for="(doc, index) in documents">
            <li
              class="side-bar__documents__doc"
              :class="{ 'side-bar__documents__doc--active': index === currentDocument }"
              :data-id="index"
              :style="documentWidth"
              :key="`${doc.fingerprint}-${index}`"
              @click="selectDocument">
              <div class="side-bar__documents__doc__image">
                <img :src="`${s3URL}/large/${doc.fingerprint}-0.jpg`"/>
                <div class="side-bar__documents__doc__image__details">
                  <b class="side-bar__documents__doc__header">{{ doc.title }}</b>
                  <!-- <span class="side-bar__documents__doc__subheader">{{ $tc('sideBarInfo.pages', doc.num_pages, { count: doc.num_pages }) }}</span> -->
                  <span class="side-bar__documents__doc__subheader" v-if="doc.num_pages == 1 || doc.pages == 1">{{ $t('sideBarInfo.onePage') }}</span>
                  <span class="side-bar__documents__doc__subheader" v-else>{{ $t('sideBarInfo.pagesPlural', { count: doc.num_pages || doc.pages }) }}</span>
                </div>
              </div>
            </li>
          </template>
        </ul>
        <a class="side-bar__button"
          @click.prevent="documentNav"
          v-if="documents.length > 1">
          <icon :name="setIcon" height="20"></icon>
        </a>
      </div>
    </div>
    <div class="side-bar__row side-bar__row--scrollable" ref="parties" v-if="parties && parties.length">
      <h3>{{ $t('sideBarInfo.parties') }}</h3>
      <template v-for="(party, index) in parties">
        <parties
          :name="party.party_title"
          :email="party.party_email"
          :key="`${party.party_id}-${index}`"
          :isSigner="party.isSigner"></parties>
      </template>
    </div>
    <div class="side-bar__locale">
      <language-switcher class="side-bar__locale__select"></language-switcher>
    </div>
    <div class="side-bar__footer" ref="footer">
      <router-link
        :to="{ name: 'Download'}"
        class="icon icon--circle"
        v-if="!$store.getters.isWidget">
        <div class="icon__title icon__title--left">{{ $t('sideBarInfo.downloadPDF') }}</div>
        <icon name="file-pdf-o" height="18" width="18"></icon>
      </router-link>
      <div class="icon icon--circle" @click="rejectDocument" v-if="!$store.getters.isWidget">
        <div class="icon__title">{{ $t('sideBarInfo.reject') }}</div>
        <icon name="remove" width="18" height="18"></icon>
      </div>
      <div class="icon icon--circle" @click="help">
        <div class="icon__title">{{ $t('sideBarInfo.help') }}</div>
        <icon name="question" width="18" height="18"></icon>
      </div>
    </div>
  </div>
</template>

<script>
import Parties from '@/components/Parties'
import LanguageSwitcher from '@/components/LanguageSwitcher'

export default {
  name: 'side-bar-info',
  components: {
    Parties,
    LanguageSwitcher
  },
  data () {
    return {
      parties: this.$store.state.parties,
      currentDocument: this.$store.state.currentDocument,
      documentWidth: 0,
      documentsListWidth: 0,
      documentsListPos: 0,
      isMobileActive: false
    }
  },
  created () {
    this.$bus.$on('nextDocument', () => { // TODO Could these be computed properties?
      this.documentsListPos = this.$store.state.currentDocument
      this.currentDocument = this.$store.state.currentDocument
    })
    this.$bus.$on('showSideBarInfo', () => {
      document.body.style.overflow = !this.isMobileActive ? 'hidden' : 'initial'
      this.isMobileActive = !this.isMobileActive
    })
    window.addEventListener('resize', this.setScrollableHeight)
  },
  mounted () {
    // 75% of the width of the sidebar
    const width = (75 / 100) * this.$el.clientWidth
    this.documentWidth = `width: ${width}px;`
  },
  updated () {
    const width = this.$el.clientWidth * this.documents.length
    const marginLeft = (((75 / 100) * this.$el.clientWidth) * this.documentsListPos)
    this.documentsListWidth = `width: ${width}px; transform: translate3d(-${marginLeft}px, 0, 0);`
    this.setScrollableHeight()
  },
  computed: {
    setIcon () {
      return this.documentsListPos === (this.documents.length - 1) ? 'chevron-left' : 'chevron-right'
    },
    downloadURL () {
      // if (this.$store.getters.requestedEnvelope.envelope_fingerprint) {
      //   return `${process.env.VUE_APP_API_URL}/download/envelope`
      // } else if (this.$store.getters.isWidget) {
      //   return `${process.env.VUE_APP_API_URL}/download/widget?widget=${this.$store.getters.requestedEnvelope.widgetCode}`
      // }

      return null // TODO Allow envelope download on preview
    },
    documents () {
      if (this.$store.state.envelope.documents && this.$store.state.envelope.documents.length) return this.$store.state.envelope.documents

      return [this.$store.state.widget]
    },
    s3URL () {
      return process.env.VUE_APP_AWS_S3_URL
    }
  },
  methods: {
    documentNav () {
      if (this.documentsListPos >= (this.documents.length - 1)) {
        this.documentsListPos = 0
      } else {
        this.documentsListPos += 1
      }
    },
    selectDocument (event) {
      const index = parseInt(event.target.getAttribute('data-id'), 10)
      this.$store.commit('nextDocument', { index })
      this.$bus.$emit('nextDocument')
    },
    rejectDocument () {
      this.$bus.$emit('openModal', 'rejectModal')
    },
    help () {
      this.$bus.$emit('openModal', 'helpModal')
    },
    setScrollableHeight () {
      if (window.innerWidth > 1025) {
        document.body.style.overflow = 'initial'
        this.isMobileActive = false
      }

      const headerHeight = 80 - 50
      let footerHeight = 0
      let documentsHeight = 0
      if (this.$refs.footer) footerHeight = this.$refs.footer.offsetHeight
      if (this.$refs.contracts) documentsHeight = this.$refs.contracts.offsetHeight

      const addition = headerHeight + footerHeight + documentsHeight
      if (this.$refs.parties) {
        this.$refs.parties.style.maxHeight = `${this.$el.offsetHeight - addition}px`
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  @import '@/styles/component-utils.sass'
  $color-side-bar-bg: #fff
  $color-side-bar-border: lighten($color-main-dark, 10%)
  $color-side-bar-footer: $color-main
  .side-bar
    position: fixed
    left: 0
    bottom: 0
    background: $color-side-bar-bg
    width: 25%
    height: calc(100% - 80px)
    padding: $spacing-base
    z-index: 1
    &__row
      position: relative
      margin-top: $spacing-base
      padding-top: $spacing-base
      &:first-child
        border-top: 0
        margin-top: 0
        padding-top: 0
      &--scrollable
        max-height: 306px
        padding-bottom: $spacing-base
        overflow: auto
        h3
          margin-bottom: -$spacing-small
    &__locale
      position: absolute
      bottom: 74px
      left: 0
      width: 100%
      background: white
      height: auto
      padding: 10px
      &__select
        width: 100%
        border: 1px solid grey
        height: 26px
    &__footer
      position: absolute
      bottom: 0
      left: 0
      padding: $spacing-base
      z-index: 10
      width: 100%
      background: $color-side-bar-footer
    &__documents
      overflow: hidden
      &__list
        padding: 0
        margin: -$spacing-base
        transition: all .25s ease
        @include clearfix
      &__doc
        list-style: none
        width: 75%
        float: left
        padding: $spacing-base
        cursor: pointer
        > div
          border: 3px solid $color-grey
          border-radius: 3px
        &__image
          height: 200px
          overflow: hidden
          margin-bottom: $spacing-small
          pointer-events: none
          position: relative
          &__details
            position: absolute
            bottom: 0
            background: rgba(0, 0, 0, 0.6)
            color: #fff
            width: 100%
            padding: 10px
        &__header
          word-break: break-all
          pointer-events: none
        &__subheader
          margin-top: $spacing-xs
          font-style: italic
          font-size: $font-size-small
          font-weight: bold
          display: block
          pointer-events: none
        &--active
          > div
            border: 3px solid $signable-secondary-1
    &__button
      position: absolute
      padding: $spacing-small
      background: #fff
      border-radius: 30px
      right: -35px
      top: 50%
      color: $color-main-dark
      padding: $spacing-small $spacing-base
      line-height: 0
      margin-top: -$spacing-large
      box-shadow: 0 5px 20px -5px $color-grey-dark
      cursor: pointer
      &:hover
        background: $color-main
        color: #fff
      .fa-icon
        margin: 0
  // Responsive
  @media screen and (max-width: $screen-size-large)
    .side-bar
      left: -325px
      width: 300px
      z-index: 999
      height: calc(100% - 55px)
      transition: left .25s ease
      border-right: 1px solid $color-border
      &--active
        left: 0
</style>
